__webpack_require__.p = "/result/delhi-election-2025/";